module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FscXVlXzIiIGRhdGEtbmFtZT0iQ2FscXVlIDIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUwLjM4IDI2LjM5Ij48dGl0bGU+YXJyb3cyPC90aXRsZT48cGF0aCBkPSJNNTAsMTIuNzUsMzcuNTgsMCwzNS40MiwyLjA5bDkuOSwxMC4ySDB2M0g0NS4wNmwtOS41OCw4LjksMiwyLjJMNDkuOSwxNC44OWgwYTEuNDgsMS40OCwwLDAsMCwuMzctLjVBMS41LDEuNSwwLDAsMCw1MCwxMi43NVoiIHN0eWxlPSJmaWxsOiM5ZmE2YWMiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/grid-arrow.svg
// module id = 371
// module chunks = 179175873700456 190794081531305